import React, { Component } from 'react';
import { connect } from 'react-redux';
import learningContent from '../../../constatns/learning';
import './index.css';
import LearningBox from './le-box';
import {originUrl} from "../../../api/apiConst";


class Learning extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }


  render() {
    const { lang } = this.props;

    return (
      <div className='page-padding'>
        <div className="learning-wrapper" style={{direction:lang==='fa' ? 'rtl' : 'ltr'}}>
          <a className="card le-box-1 p-2-rem px-3" href="https://learning.emofid.com/events/" target="_blank" rel="noopener noreferrer">
            <header className="text-center color-dark-blue font-bold font-20-px font-sm-20-px mb-2">کلاس های آموزشی آنلاین بورس ویو</header>
            <div className="text-center color-dark-blue font-14-px font-sm-14-px mb-2">تقویم آموزشی کارگزاری مفید</div>
          </a>

          <a className="card le-box-2 p-2-rem px-3" href="https://learning.emofid.com/what-is-the-bourse-view/" target="_blank" rel="noopener noreferrer">
            <header className="text-center color-dark-blue font-bold font-20-px font-sm-20-px mb-2">راهنمای کاربری و آموزش بورس ویو</header>
            <div className="text-center color-dark-blue font-14-px font-sm-14-px mb-2">وبسایت آموزش کارگزاری مفید</div>
          </a>

          {
            learningContent.map((le, i)=>{
              return <LearningBox key={le.href + i} boxItem={le} index={i + 1} lang={lang}/>
            })
          }

          <a className="card le-box-31 p-2-rem px-3" href="https://learning.emofid.com/" target="_blank" rel="noopener noreferrer">
            <header className="text-center color-dark-blue font-bold font-16-px font-sm-16-px mb-2">سامانه جامع آموزش کارگزاری مفید</header>
            <div className="text-center color-dark-blue font-bold font-14-px font-sm-14-px mb-2">Learning.Emofid.com</div>
          </a>

          <a className="card le-box-32 p-2-rem px-3" href={originUrl} target="_blank" rel="noopener noreferrer">
            <header className="text-center color-dark-blue font-bold font-16-px font-sm-16-px mb-2">سامانه جامع تحلیل بازار بورس ویو</header>
            <div className="text-center color-dark-blue font-bold font-14-px font-sm-14-px mb-2">www.BourseView.com</div>
          </a>

          <a className="card le-box-33 p-2-rem px-3" href="https://www.emofid.com/" target="_blank" rel="noopener noreferrer">
            <header className="text-center color-dark-blue font-bold font-16-px font-sm-16-px mb-2">وب سایت کارگزاری مفید</header>
            <div className="text-center color-dark-blue font-bold font-14-px font-sm-14-px mb-2">www.Emofid.com</div>
          </a>

          <div className="card le-box-34 p-2-rem px-3">
            <header className="text-center color-dark-blue font-bold font-16-px font-sm-16-px mb-2">تماس با واحد فروش</header>
            <div className="text-center color-dark-blue font-bold font-14-px font-sm-14-px mb-2">021-81903000</div>
          </div>

          <div className="card le-box-35 p-2-rem px-3">
            <header className="text-center color-dark-blue font-bold font-16-px font-sm-16-px mb-2">مرکز تماس و پشتیبانی کارگزاری مفید</header>
            <div className="text-center color-dark-blue font-bold font-14-px font-sm-14-px mb-2">021-8700</div>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  lang: state.request.lang
});

export default connect(mapStateToProps, null)(Learning);
